import DOMPurify from 'dompurify';

import { Address } from '@/core/graphql/generated/types';

import { getAddressParts } from '../getAddressParts';

export const formatAddress = (
	address: Address | null | undefined
): string | null => {
	if (
		!address ||
		(!address.streetAddress1Cda_V &&
			!address.cityCda_V &&
			!address.countryCda_V)
	) {
		return null;
	}

	return DOMPurify.sanitize(getAddressParts(address).join(', '));
};
